export const WHITELISTED_APPS = ['https://explorer.zero.tech', 'https://swap-z.platform.gateway.fm'];
